import { render, staticRenderFns } from "./AddOnOrders.vue?vue&type=template&id=685e6f1f"
import script from "./AddOnOrders.vue?vue&type=script&lang=js"
export * from "./AddOnOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports